module.exports = __webpack_public_path__ + "img/twin.ff91ca0b.png";